export default __webpack_public_path__ + "static/media/icaew_xl2.c154d527.png";